const modifiers = require('./modifiers');

class Operation extends String {
  reversal() {
    return new Operation(`${this}${modifiers.reversal}`);
  }

  refund() {
    return new Operation(`${this}${modifiers.refund}`);
  }

  manual() {
    return new Operation(`${this}${modifiers.manual}`);
  }

  rollback() {
    return new Operation(`${this}${modifiers.rollback}`);
  }

  static create(rawOperation) {
    return new Operation(rawOperation);
  }
}

// Keep sync with https://github.com/transfeera/go-infra/blob/de9b5f2bd18fcf177e153e8ec3bbbda22b0e1d93/pkg/ledger/constants.go#L12.
const operations = {
  // Outbound Operations - send money to outside the institution.
  outboundTransfer: new Operation('transfeera.account:v1:outbound:transfer'),
  outboundBoletoPayment: new Operation('transfeera.account:v1:outbound:boleto'),
  outboundWithdraw: new Operation('transfeera.account:v1:outbound:withdraw'),

  // Inbound Operations - receive money from outside the institution.
  inboundTransfer: new Operation('transfeera.account:v1:inbound:transfer'),
  inboundBoletoPayment: new Operation('transfeera.account:v1:inbound:boleto'),
  inboundDeposit: new Operation('transfeera.account:v1:inbound:deposit'),

  // Block Operations - block money from an account.
  blockMed: new Operation('transfeera.account:v1:block:med'),
  blockCourt: new Operation('transfeera.account:v1:block:court'),

  // Internal Operations - operations that are not visible to the client.
  internalMicroDeposit: new Operation('transfeera.internal:v1:contacerta:microdeposit'),
  internalBalanceTransfer: new Operation('transfeera.internal:v1:balance:transfer'),
  internalCourtPayment: new Operation('transfeera.internal:v1:court:payment'),
  internalPendingCredit: new Operation('transfeera.internal:v1:pending:credit'),
  internalPendingDebit: new Operation('transfeera.internal:v1:pending:debit'),
  internalFailure: new Operation('transfeera.internal:v1:failure'),

  // General Operations - operations that are not specific to any type of operation.
  debit: new Operation('transfeera.account:v1:debit'),
  credit: new Operation('transfeera.account:v1:credit'),
  balance: new Operation('transfeera.account:v1:balance')
};

// Define semantic aliases.
operations.outboundPix = operations.outboundTransfer;
operations.outboundTed = operations.outboundTransfer;
operations.inboundPix = operations.inboundTransfer;
operations.inboundTopUp = operations.inboundDeposit;

module.exports = operations;
